import { app } from "./main-app"
import ConfirmationService from "primevue/confirmationservice"

app.use(ConfirmationService)
